module.exports = __webpack_public_path__ + "media/process/Process-Badges-Team-328597f6.svg";